export const isMobile = () =>
  window.matchMedia && window.matchMedia("(max-width: 992px)").matches;
